import { Tooltip } from "./Tooltip";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

export function SetInfo(header, _cell, viewHandleClick, deleteHandleClick) {
	const data = _cell.render("Cell").props.row.original;

	if (header === "") {
		return (
			<td>
				<div
					className="row"
					style={{ alignItems: "center", justifyContent: "center" }}
				>
					<Tooltip text="View">
						<div
							style={{ padding: "0 5px" }}
							onClick={() => viewHandleClick(data)}
						>
							<RemoveRedEyeIcon />
						</div>
					</Tooltip>
					{deleteHandleClick ? (
						<Tooltip text="Delete">
							<div
								style={{ padding: "0 5px" }}
								onClick={() => deleteHandleClick(data)}
							>
								<DeleteForeverIcon />
							</div>
						</Tooltip>
					) : (
						<></>
					)}
				</div>
			</td>
		);
	}

	if (header === "Reference No.") {
		const value = _cell.render("Cell").props.value;

		const formattedNumber = value.toString().padStart(6, "0");

		if (data.requestTypeId === 1) {
			return <td>LV-{formattedNumber}</td>;
		} else if (data.requestTypeId === 2) {
			return <td>CS-{formattedNumber}</td>;
		} else if (data.requestTypeId === 3) {
			return <td>OT-{formattedNumber}</td>;
		} else if (data.requestTypeId === 4) {
			return <td>CH-{formattedNumber}</td>;
		} else if (data.requestTypeId === 5) {
			return <td>OS-{formattedNumber}</td>;
		}
	}

	if (header === "Request Date") {
		const date = new Date(_cell.render("Cell").props.value);

		const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
		const dd = date.getDate();
		const yyyy = date.getFullYear();

		const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

		return <td>{formattedDateFrom}</td>;
	}

	return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}